module.exports = __webpack_public_path__ + "img/icon-card-none.7e2703a4.svg";